import React from "react";
import "./Conversao.css";
import {
  MessageCircleX,
  MapPinOff,
  UsersRound,
  MessageSquareWarning,
  AlertTriangle,
  LineChart,
  X,
  FileText,
  UserX,
  Target,
  BarChart3,
} from "lucide-react";

const Conversao = () => {
  return (
    <section className="maquina-section" data-aos="fade-up">
      <div className="maquina-container">
        <div className="maquina-grid">
          <div className="maquina-left">
            <h2 className="maquina-title">
              <X
                size={50}
                strokeWidth={3}
                style={{
                  backgroundColor: "#cfad5d33",
                  borderRadius: "18px",
                  marginRight: "1rem",
                }}
              />
              Você já tentou...
            </h2>
            <ul className="maquina-list">
              <li>
                <MessageCircleX className="icon" /> Tráfego pago direto pro
                WhatsApp
              </li>
              <li>
                <MessageCircleX className="icon" /> Social media que posta 3
                vezes por semana
              </li>
              <li>
                <MessageCircleX className="icon" /> Agências que prometem
                curtidas e seguidores
              </li>
              <li>
                <MessageCircleX className="icon" /> Contratar alguém pra
                "responder os leads"
              </li>
              <li>
                <MessageCircleX className="icon" /> Treinar a equipe pra
                “atender bem”
              </li>
            </ul>

            <p className="maquina-sub">
              ...mas o consultório não cresce como deveria.
            </p>

            <h3 className="maquina-warning">O que está te travando hoje:</h3>
            <ul className="maquina-problems">
              <li>
                <MapPinOff className="icon" /> Você não sabe de onde vêm seus
                pacientes (ou por que alguns não vêm)
              </li>
              <li>
                <UsersRound className="icon" /> Sua equipe responde os leads,
                mas não nutre relacionamento
              </li>
              <li>
                <MessageSquareWarning className="icon" /> Sua comunicação nas
                redes não se conecta com seu público
              </li>
              <li>
                <AlertTriangle className="icon" /> Você vive na ansiedade de
                depender do próximo lead
              </li>
              <li>
                <LineChart className="icon" /> Você não tem controle sobre o que
                acontece no comercial
              </li>
            </ul>
          </div>

          {/* COLUNA DA DIREITA */}
          <div className="maquina-right">
            <div className="maquina-virada">
              <h3 className="maquina-virada-title">
                A virada aconteceu quando percebemos isso:
              </h3>
              <p className="maquina-virada-text">
                O segredo não está no tráfego.
                <br />
                Está na <span className="highlight">gestão</span>.
              </p>
              <p className="maquina-virada-desc">
                Quando há 3 anos atrás eu assumi a gestão comercial e marketing
                estratégico de uma clínica que saiu de um faturamento de 10 mil
                para <strong>R$500 mil mês</strong>, eu entendi uma coisa: Uma
                construção de conteúdo estratégica e um
                <span className="highlight">
                  {" "}
                  CRM bem implementado muda tudo
                </span>
              </p>
            </div>

            <ul className="maquina-benefits">
              <li>
                <FileText className="icon" /> O conteúdo estratégico é a única
                ferramenta que qualifica o lead
              </li>
              <li>
                <UserX className="icon" /> Com o CRM você não desperdiça nenhum
                lead
              </li>
              <li>
                <Target className="icon" /> Com o CRM você sabe exatamente o que
                precisa ser feito com cada oportunidade
              </li>
              <li>
                <BarChart3 className="icon" /> Com o CRM você acompanha o
                desempenho do time em tempo real
              </li>
              <li>
                <LineChart className="icon" /> Com o CRM você cria
                previsibilidade de faturamento
              </li>
            </ul>

            <p className="maquina-final">
              Você transforma o comercial em{" "}
              <strong>máquina de conversão</strong> — e não de esperança.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Conversao;
